<template>
  <v-col cols="4" class="text-center">
    <div v-if="!loading">
      <h1 class="text-center">{{device.name}} : {{device_value._value}}</h1>
      <div v-if="device_value" class="text-center">
        <v-gauge :value="device_value._value"
                 width="350px"
                 :options="{fontSize:30,pointer:{color:'#D20003',length:0.7,strokeWidth:0.07}}"
        />
        <h3 v-if="device_value._time">
          {{ new Date(device_value._time).toLocaleString("fa-ir").split(",")[1] }}
        </h3>
        <small v-if="device_value._time">
          {{ new Date(device_value._time).toLocaleString("fa-ir").split(",")[0] }}
        </small>
        <h3 v-else>دیتایی از این سنسور موجود نیست</h3>
        <small v-if="set">
          set : {{ set.value }}
        </small>

      </div>
    </div>

    <v-progress-circular
        v-else
        :size="100"
        :width="7"
        color="#d20003"
        indeterminate
    ></v-progress-circular>
  </v-col>
</template>

<script>
import axios from "axios";
import VGauge from 'vgauge';


export default {
  name: "BoardDegree",
  props: ["device", "board_id", "set"],
  components:{VGauge},
  data: () => ({
    key: localStorage.getItem("key"),
    device_value: null,
    loading:false,
    intervalId: null,
  }),
  created() {
    this.fetch_data();
    this.intervalId = setInterval(()=>{
    this.fetch_data()
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    fetch_data() {
      axios
        .get(
          `${this.BACKEND_LINK}/api/devices-data/device/?pk=${this.board_id}&device=S&field_name=${this.device.value}&last=true`,
          {
            headers: { Authorization: `Token ${this.key}` },
          }
        )
        .then((response) => {
          if (response.data.length) {
            this.device_value = response.data[0];
          }else{
            this.device_value = {_time:false, _value:999}
          }
        })
        .catch((error) => {
          this.$snotify.error(
            "خطا در دریافت اطلاعات",
            `کد ${error.response.status}`
          );
        })
          .finally(()=>{
            this.loading=false;
          })
    },
  },
};
</script>
